<img    *ngIf   =   "imgURL"
        [src]   =   "imgURL">